<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 mt-4">
            <div class="row" v-if="selectedTiers">
              <div class="col-md-12">
                <table
                  class="card table table-sm table-custom-primary table-bordered mb-0"
                >
                  <tbody>
                    <tr class="d-flex">
                      <td class="col-12 text-center font-weight-bold">
                        Tiers concerné
                      </td>
                    </tr>
                    <tr class="d-flex font-size-17 font-weight-bold">
                      <td class="col-12 d-flex justify-content-between px-2">
                        <span>Nom :</span><span>{{ selectedTiers.nom }}</span>
                      </td>
                    </tr>
                    <tr class="d-flex font-size-17 font-weight-bold">
                      <td class="col-12 d-flex justify-content-between px-2">
                        <span>Email :</span
                        ><span>{{ selectedTiers.email }}</span>
                      </td>
                    </tr>
                    <tr class="d-flex font-size-17 font-weight-bold">
                      <td class="col-12 d-flex justify-content-between px-2">
                        <span>Client/Prospect :</span
                        ><span>{{ selectedTiers.client_prospect }}</span>
                      </td>
                    </tr>

                    <tr class="d-flex font-size-17 font-weight-bold">
                      <td class="col-12 d-flex justify-content-between px-2">
                        <span>Type :</span><span>{{ selectedTiers.type }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <b-alert
              :show="form.errors.has('tiers')"
              dismissible
              variant="danger"
              class="mt-1"
            >
              <span v-html="form.errors.get('tiers')"></span>
            </b-alert>
            <div class="row mb-2">
              <div class="col-md-12 text-right">
                <button
                  type="button"
                  class="btn btn-custom-primary mr-4"
                  style="min-width: 100px"
                  @click="showModalSelectTiers()"
                >
                  Choisir <span v-if="selectedTiers"> un autre tiers</span
                  ><span v-else>le tiers</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row bg-white">
          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="contact_nom"
                >Nom <span class="text-danger">*</span></label
              >
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('nom'),
                }"
                id="contact_nom"
                v-model="form.nom"
                type="text"
                placeholder="Nom"
                maxlength="50"
                required
              />
              <has-error :form="form" field="nom"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4 mt-md-0">
            <div class="form-group">
              <label for="contact_prenom">Prénom </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('prenom'),
                }"
                id="contact_prenom"
                v-model="form.prenom"
                type="text"
                placeholder="Prénom"
                maxlength="50"
              />
              <has-error :form="form" field="prenom"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
            <div class="form-group">
              <label for="contact_poste_fonction">Poste / Fonction </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('poste_fonction'),
                }"
                id="contact_poste_fonction"
                v-model="form.poste_fonction"
                type="text"
                placeholder="Poste / Fonction"
                maxlength="50"
              />
              <has-error :form="form" field="poste_fonction"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_pays">Pays </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('pays'),
                }"
                id="contact_pays"
                v-model="form.pays"
                type="text"
                placeholder="Pays"
                maxlength="50"
              />
              <has-error :form="form" field="pays"></has-error>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_ville">Ville </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('ville'),
                }"
                id="contact_ville"
                v-model="form.ville"
                type="text"
                placeholder="Ville"
                maxlength="50"
              />
              <has-error :form="form" field="ville"></has-error>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_departement">Département </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('departement'),
                }"
                id="contact_departement"
                v-model="form.departement"
                type="text"
                placeholder="Département"
                maxlength="50"
              />
              <has-error :form="form" field="departement"></has-error>
            </div>
          </div>

          <div class="col-md-4 col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_email">Email </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('email'),
                }"
                id="contact_email"
                v-model="form.email"
                type="email"
                placeholder="Email"
                maxlength="100"
              />
              <has-error :form="form" field="email"></has-error>
            </div>
          </div>
          <div class="col-md-4 col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_telephone">Téléphone </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('telephone'),
                }"
                id="contact_telephone"
                v-model="form.telephone"
                type="text"
                placeholder="Téléphone"
                maxlength="20"
              />
              <has-error :form="form" field="telephone"></has-error>
            </div>
          </div>
          <div class="col-md-4 col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_fax">Fax </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('fax'),
                }"
                id="contact_fax"
                v-model="form.fax"
                type="text"
                placeholder="Fax"
                maxlength="20"
              />
              <has-error :form="form" field="fax"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_code_postal">Code postal </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('code_postal'),
                }"
                id="contact_code_postal"
                v-model="form.code_postal"
                type="text"
                placeholder="Code postal"
                maxlength="20"
              />
              <has-error :form="form" field="code_postal"></has-error>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-n4">
            <div class="form-group">
              <label for="contact_adresse">Adresse </label>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('adresse'),
                }"
                id="contact_adresse"
                v-model="form.adresse"
                type="text"
                placeholder="Adresse"
                maxlength="100"
              />
              <has-error :form="form" field="adresse"></has-error>
            </div>
          </div>
        </div>
        <div class="row mt-4 mb-4">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>

    <ModalSelectTiers
      ref="modalSelectTiers"
      :titleModal="titleModal"
      @onTiersSelected="onTiersSelected"
    />
  </div>
</template>

<script>
import URL from '@/http/crm/tiers_contact/contact';
import ModalSelectTiers from '../ModalSelectTiers.vue';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        tiers: '',
      }),
      titleModal: '',
      selectedTiers: null,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    ModalSelectTiers,
  },

  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .all([window.axios.get(URL.CONTACT + '/' + this.id)])
        .then(
          window.axios.spread((resp) => {
            Object.assign(this.form, resp.data.tiersContact);
            this.selectedTiers = this.form.tiers;
            this.form.tiers = '';
          })
        )
        .catch();
    },
    submit() {
      this.form.tiers = this.selectedTiers ? this.selectedTiers.uuid : '';
      this.form
        .put(URL.CONTACT + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
    showModalSelectTiers() {
      this.titleModal = 'Sélection du tiers pour le contact';
      this.$nextTick(() => {
        this.$refs.modalSelectTiers.showModal();
      });
    },
    onTiersSelected(tiers) {
      this.selectedTiers = tiers;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
